import React, { ReactElement } from 'react';
import { useFieldVisibilityModel } from './model';
import { FieldVisibilityPresentational } from './presentational';

export type { FieldOnView } from './types';

export function FieldVisibility(): ReactElement {
  const props = useFieldVisibilityModel();
  return <FieldVisibilityPresentational {...props} />;
}
